"use strict";
import { DragElement } from "../../lib/drag.js";
import { isValidUrl } from "../../lib/utils.js";
import { Basic } from "../basic.ts";
import i18next from "i18next";
/**
 * @class MSPopUpWindow
 * @extends Basic
 * @classdesc Всплывающее окно
 * */
export class MSPopUpWindow extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "dragable",
            "modal",
            "title",
            "showtitle",
            "titlecolor",
            "titlefontcolor",
            "minimized",
            "closable",
            "resize",
            "sizetocontent",
            "mini",
            "opendialogpoint",
            "boundsrestricted",
            "offsetx",
            "offsety",
            "context",
            "default",
            "scale",
            "onclose",
            "maxwidth",
            "wincategory",
            "backgroundcolor"
        ]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });

        this.style.boxSizing = "border-box";
        this.templateActive = window.activeMonitorTemplateId || window._globalParams.DefaultScreenId
        this.screenOptions = JSON.parse(window._globalParams.ScreensOptions)[this.templateActive]

        shadowRoot.innerHTML = `
        <style>
        :host {
            overflow: unset;
            z-index: 10000000;
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0; margin: 0; padding: 0;
            background-color: #00000030;
            display: none;
        }
        .disabled {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(82, 82, 82, 0.5);
            z-index: 10000000;
            display: none;
        }
        .pop_up {
            position: absolute;
            display: flex;
            flex-direction: column;
            z-index: 1;
            border: 1px solid #6287C6;
            box-shadow: none;
            box-sizing: border-box;
            overflow: hidden;
            border-radius: ${this.screenOptions.DialogBorderRadius}px;
            clip-path: inset(0 round ${this.screenOptions.DialogBorderRadius}px);

        }

        .pop_up__header {
            cursor: default;
            width: 100%;
            height: ${this.screenOptions.DialogHeaderSize}px;
            min-height: ${this.screenOptions.DialogHeaderSize}px;
            background: #E0E7ED;
            display: flex;
            justify-content: space-between;
            padding-left: 10px;
            align-items: center;
            box-sizing: border-box;
            color: #1B1A1A;
            margin-bottom: -1;
        }

        .pop_up__header span {
            font-size: ${this.screenOptions.DialogFontSize}px;
            font-family: "${this.screenOptions.DialogFontName}";
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .header__btngroup {
            height: 100%;
            display: flex;
        }

        .header__btngroup button {
            width: ${this.screenOptions.DialogHeaderSize}px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            background: none;
            border: none;
            transition: .4s;
            outline: none;
            cursor: pointer;
        }

        .header__btngroup button:hover {
            background: rgba(37, 100, 214, 0.5);
        }

        .btn_hidden::before {
            content: '';
            width: 50%;
            height: 1px;
            position: absolute;
            background: #1B1A1A;
            bottom: 30%;
        }

        .btn_close::before {
            width: 50%;
            height: 1px;
            content: '';
            position: absolute;
            background: #1B1A1A;
            transform: rotate(45deg);
        }

        .btn_close::after {
            width: 50%;
            height: 1px;
            content: '';
            position: absolute;
            background: #1B1A1A;
            transform: rotate(-45deg);
        }

        .pop_up__body {
            overflow: hidden;
            background: white;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
        }

        .body__name {
            line-height: 18px;
            font-size: 13px;
            color: #1B1A1A;
        }

        .body__btn {
            cursor: pointer;
            width: 85px;
            height: 24px;
            line-height: 1;
            background: linear-gradient(180deg, #4574CF 0%, #2B5099 100%);
            outline: none;
            border: 1px solid #345AA4;
            box-sizing: border-box;
            font-size: 11px;
            color: #FDFDFD;
            margin-top:8px;
        }

        label {
            cursor: pointer;
        }

        .body__labelgroup {
            display: flex;
            align-items: center;
            margin-top: 16px;
        }

        .body__btn + .body__labelgroup {
            margin-top: 32px;
        }

        .active {
            border: 1px solid #2C6FD7;
            box-shadow: var(--popup-shadow);
            z-index: 4;
            overflow: hidden;
            border-radius: ${this.screenOptions.DialogBorderRadius}px;
            box-sizing: border-box;
        }

        .active .pop_up__header {
            background: #2C6FD7;

        }

        .active .header__btngroup button::before,
        .active .header__btngroup button::after {
            background: white;
        }

        .hidder {
            height: 0px;
            padding: 0;
        }

        .active .header__btngroup button:hover {
            background: rgba(0, 0, 0, 0.3);
        }

        .header_colored_white button::before,
        .active .header_colored_white button::before,
        .header_colored_white button::after,
        .active .header_colored_white button::after{
            background: rgb(22, 22, 22);
        }

        .header_colored_white button:hover,
        .active .header_colored_white button:hover {
            background: rgba(22, 22, 22, 0.3);
        }

        .active .header_colored_black  button::before,
        .header_colored_black  button::before,
        .active .header_colored_black  button::after,
        .header_colored_black  button::after {
            background: rgb(247, 244, 244);
        }

        .active .header_colored_black  button:hover,
        .header_colored_black  button:hover {
            background: rgba(245, 241, 241, 0.3);
        }

        </style>
        <div class='pop_up' id="popup" style='user-select: none; --popup-shadow: 0px 3px 10px rgba(35, 39, 76, 0.5);'>
            <div class="pop_up__header" id="title">
                <span id="text"></span>
                <div class="header__btngroup">
                    <button id="minimize" class='btn_hidden'></button>
                    <button id="closed" class='btn_close'></button>
                </div>
            </div>
            <div id="work" class="pop_up__body" style='overflow: hidden;'>
            <slot></slot>
            <div id="disabled" class="disabled"></div>
            </div>
            <div style="width:10px;position:absolute;right:-5px;bottom:0;top:0;cursor:ew-resize;z-index:1;" id="r_rsize"></div>
            <div style="height:10px;position:absolute;right:0;bottom:-5;left:0;cursor:ns-resize;z-index:1;" id="b_rsize"></div>
            <div style="height:15px;width:15px;position:absolute;right:-8px;bottom:-8px;cursor:nw-resize;z-index:1;" id="rsize"></div>
        </div>
        `;
        this._popup = shadowRoot.getElementById("popup");
        this._disabled = shadowRoot.getElementById("disabled");
        this._title = shadowRoot.getElementById("title");
        this._caption = shadowRoot.getElementById("text");
        this._r_resizeEl = shadowRoot.getElementById("r_rsize");
        this._r_resizeEl.onmousedown = this._reSizeWindow.bind(this, "r");
        //         this._r_resizeEl.ontouchstart = this._reSizeWindow.bind(this, 'r');
        this._onRTouchStart = this._reSizeWindow.bind(this, "r");
        this._r_resizeEl.addEventListener(
            "touchstart",
            this._onRTouchStart,
            false
        );
        this._b_resizeEl = shadowRoot.getElementById("b_rsize");
        this._b_resizeEl.onmousedown = this._reSizeWindow.bind(this, "b");
        //         this._b_resizeEl.ontouchstart = this._reSizeWindow.bind(this, 'b');
        this._onBTouchStart = this._reSizeWindow.bind(this, "b");
        this._b_resizeEl.addEventListener(
            "touchstart",
            this._onBTouchStart,
            false
        );
        this._resizeEl = shadowRoot.getElementById("rsize");
        this._resizeEl.onmousedown = this._reSizeWindow.bind(this, "n");
        //         this._resizeEl.ontouchstart = this._reSizeWindow.bind(this, 'n');
        this._onNTouchStart = this._reSizeWindow.bind(this, "n");
        this._resizeEl.addEventListener(
            "touchstart",
            this._onNTouchStart,
            false
        );

        this.isMini = false;
        this._work = shadowRoot.getElementById("work");
        this._minimized = shadowRoot.getElementById("minimize");
        this._minimized.onclick = () => {
            this.mini = !this.mini;
        };

        this._close = shadowRoot.getElementById("closed");
        this._close.onclick = () => {
            this.close();
        };

        this.onmousedown = e => {
            if (e.needClickIgnode) return;
            this._upWindow();
        };
        this.onDefault = this.onDefault.bind(this);
        this.showtitle = true;
        this._isPopupManualResizing = false;
        this._borderthickness = 1;
        // this._minimize();
        this.cssElem = shadowRoot.querySelector("style");
        this._upWindow();
        this.afterSwitch = this.afterSwitch.bind(this);
        window.addEventListener("ms_message", this.afterSwitch);
        this._title.addEventListener('mousedown', this._startDrag.bind(this))
    }

    get backgroundcolor() {
        return this._backgroundcolor;
    }
    set backgroundcolor(value) {
        this._backgroundcolor = value;
        const c = this.tryToGetUserColor(value);
        if (this._work) this._work.style.backgroundColor = c;
    }
    
    _startDrag(e) {
        e.preventDefault();
        const scaleX = this.scaleXX || this.scale || 1;
        const scaleY = this.scaleYY || this.scale || 1;

        let shiftX = (e.clientX - this._popup.getBoundingClientRect().left);
        let shiftY = (e.clientY - this._popup.getBoundingClientRect().top);

        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;

        const popupWidth = this._popup.clientWidth * scaleX;
        const popupHeight = this._popup.clientHeight * scaleY;

        const onMouseMove = (e) => {
            if (this.popupUrl && !this._lockPointerEvents) {
                const iframe = this._msWin.querySelector("iframe");
                if (iframe) {
                    iframe.style.pointerEvents = "none";
                    this._lockPointerEvents = true;
                }
            }

            if (!this._lockBimPointerEvents) {
                this._lockBimPointerEvents = true;
                document.querySelectorAll("ms-bimframe").forEach(item => {
                    const iframe = item.querySelector("iframe");
                    if (!iframe) {
                        this._lockBimPointerEvents = false;
                        return;
                    }
                    iframe.style.pointerEvents = "none";
                });
            }

            const currentX = this.x || 0;
            const currentY = this.y || 0;

            let newX = e.clientX - shiftX - currentX;
            let newY = e.clientY - shiftY - currentY;

            if (this._boundsrestricted) {
                if (newX + currentX < 0) newX = -currentX;
                if (newX + popupWidth + currentX > viewportWidth) newX = viewportWidth - popupWidth - currentX;

                if (newY + currentY < 0) newY = -currentY;
                if (newY + popupHeight + currentY > viewportHeight) newY = viewportHeight - popupHeight - currentY;
            }

            this._popup.style.transform = `translate(${newX}px, ${newY}px) scale(${scaleX}, ${scaleY})`;
            this._popup.style.transformOrigin = "top left";

            this.lastPosition = { x: newX / scaleX, y: newY / scaleY };
            this.positionManuallyChanged = true;
        };

        const onMouseUp = () => {
            this._lockPointerEvents = false;
            if (this.popupUrl) {
                const iframe = this._msWin.querySelector("iframe");
                if (iframe) {
                    iframe.style.pointerEvents = "auto";
                }
            }

            this._lockBimPointerEvents = false;
            document.querySelectorAll("ms-bimframe").forEach(item => {
                const iframe = item.querySelector("iframe");
                if (iframe) {
                    iframe.style.pointerEvents = "auto";
                }
            });

            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("blur", onMouseUp);
        };

        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        window.addEventListener("blur", onMouseUp);
    }


    get scale() {
        return this._scale;
    }
    set scale(value) {
        this._scale = Number(value);
        if (this._scale === 1) {
            this._popup.style.transformOrigin = "";
            this._popup.style.transform = "";
        } else {
            this._popup.style.transformOrigin = "0 0";
            this._popup.style.transform = `scale(${this._scale})`;
        }
    }

    get isvisible() {
        return this._isvisible;
    }
    set isvisible(value) {
        this._isvisible = value;
        this.style.visibility = this._toBool(value) ? "" : "hidden";
    }

    /**
     * Ширина
     * @type {number}
     */
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        const tmp = Number(value);
        if (tmp) {
            this._popup.style.width = this._setValueUnit(tmp);
            this._work.style.width = this._setValueUnit(tmp);
            this._calcSize();
        }
    }
    /**
     * Высота
     * @type {number}
     */
    get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        const tmp = Number(value);
        if (tmp) {
            this._popup.style.height = this._setValueUnit(value);
            this._work.style.height = this._setValueUnit(value);
            this._calcSize();
        }
    }

    get minimized() {
        return this._mini;
    }
    set minimized(value) {
        this._mini = this._toBool(value);
        const hideMinimized = this.screenOptions?.DialogBorderRadius > 85;
        if (this._mini && !hideMinimized) {
            this._minimized.style.display = '';
        } else {
            this._minimized.style.display = 'none';
        }
    }

    get closable() {
        return this._closable;
    }
    set closable(value) {
        this._closable = this._toBool(value);
        const hideClose = this.screenOptions?.DialogBorderRadius > 55;
        if (this._closable && !hideClose) {
            this._close.style.display = '';
        } else {
            this._close.style.display = 'none';
        }
    }

    get showtitle() {
        return this._showtitle;
    }
    set showtitle(value) {
        this._showtitle = this._toBool(value);
        this._title.style.display = this._showtitle ? "flex" : "none";
        if (this._dragable && this._dnd && this._showtitle) {
            this._dnd.setDragZone(this._title);
        }
    }

    get title() {
        return this._titletext;
    }
    set title(value) {
        this._titletext = value;
        this._caption.innerText = value;
    }

    get modal() {
        return this._modal;
    }
    set modal(value) {
        this._modal = value;
        const mod = this._toBool(value);
        if (mod) {
            this.style.overflow = "hidden";
            this.style.right = "0";
            this.style.bottom = "0";
            this.style.zIndex = "20000000";
        } else {
            this.style.overflow = "unset";
            this.style.right = "unset";
            this.style.bottom = "unset";
            this.style.zIndex = "10000000";
        }
    }

    get dragable() {
        return this._dragable;
    }
    set dragable(value) {
        this._dragable = value;
        if (this._dragable) {
            if (!this._dnd && this._popup) {
                if (this._showtitle) {
                    this._dnd = new DragElement(this._popup, this._title, {
                        controlPosition: this._boundsrestricted,
                        scale: this._scale || 1,
                    });
                    this._title.removeEventListener('mousedown', this._dnd._dragMouse, false)
                } else {
                    this._dnd = new DragElement(this._popup, this._popup, {
                        controlPosition: this._boundsrestricted,
                        scale: this._scale || 1,
                    });
                }
            }
        }
    }

    get titlefontcolor() {
        return this._titlefontcolor;
    }
    set titlefontcolor(v) {
        this._titlefontcolor = v;
        this._title.style.color = v;
    }

    get titlecolor() {
        return this._titlecolor;
    }
    set titlecolor(value) {
        this._titlecolor = value;
        value = this.tryToGetUserColor(value);
        this._title.style.backgroundColor = value;
        //if (!this.titlefontcolor) {
        const tmp = this.colorValues(value);
        if (tmp && this.colourIsLight(tmp[0], tmp[1], tmp[2])) {
            this._title.classList.remove("header_colored_black");
            this._title.classList.add("header_colored_white");
        } else {
            this._title.classList.remove("header_colored_white");
            this._title.classList.add("header_colored_black");
        }
    }

    get bordercolor() {
        return this._bordercolor;
    }
    set bordercolor(value) {
        this._bordercolor = value;
        this._popup.style.borderColor = this.tryToGetUserColor(value);
    }

    get borderthickness() {
        return this._borderthickness;
    }
    set borderthickness(value) {
        this._borderthickness = value;
        this._popup.style.borderWidth = `${value}px`;
    }

    get borderstyle() {
        return this.borderstyle;
    }
    set borderstyle(value) {
        this._borderstyle = value;
        const type = window._enums.BorderStyleType[value];
        switch (type) {
            case 0:
                this._popup.style.borderStyle = "solid";
                break;
            case 1:
                this._popup.style.borderStyle = "dashed";
                break;
            case 2:
                this._popup.style.borderStyle = "dotted";
                break;
            case 3:
                this._popup.style.borderStyle = "hidden";
                break;
        }
    }

    get opacity() {
        return this._opacity;
    }
    set opacity(value) {
        this._opacity = value;
        this._popup.style.opacity = Number(this._opacity) / 100;
    }

    get sizetocontent() {
        return this._sizetocontent;
    }
    set sizetocontent(value) {
        this._sizetocontent = window._enums.SizeToContentType[value];
    }

    get resize() {
        return this._resize;
    }
    set resize(value) {
        this._resize = this._toBool(value);
        if (this._resize) {
            this._resizeEl.style.display = "block";
            this._b_resizeEl.style.display = "block";
            this._r_resizeEl.style.display = "block";
        } else {
            this._resizeEl.style.display = "none";
            this._b_resizeEl.style.display = "none";
            this._r_resizeEl.style.display = "none";
        }
    }

    get mini() {
        return !this._miniState;
    }
    set mini(value) {
        this._miniState = !this._toBool(value);
        if (this._miniState) {
            this._work.style.display = "block";
            this._popup.style.height = this.__popHeigiht;
            this._resizeEl.style.display = this.__popResize;
            this._b_resizeEl.style.display = this.__popResize;
            this._r_resizeEl.style.display = this.__popResize;
        } else {
            this._work.style.display = "none";
            this.__popHeigiht = this._popup.style.height;
            this._popup.style.height = "";
            this.__popResize = this._resizeEl.style.display;
            this._resizeEl.style.display = "none";
            this._b_resizeEl.style.display = "none";
            this._r_resizeEl.style.display = "none";
        }
    }

    get opendialogpoint() {
        return this._opendialogpoint;
    }
    set opendialogpoint(value) {
        this._opendialogpoint = Number(value);
    }

    get offsetx() {
        return this._offsetx;
    }
    set offsetx(value) {
        this._offsetx = value;
    }

    get offsety() {
        return this._offsety;
    }
    set offsety(value) {
        this._offsety = value;
    }

    get context() {
        return this._context;
    }
    set context(value) {
        this._context = value;

        const el =
            this._context.detail && this._context.detail.el
                ? this._context.detail.el
                : this._context.target || this._context.currentTarget;
        const elRect = el.getBoundingClientRect();

        const sh = Number(el.clientHeight);
        const sw = Number(el.clientWidth);
        const scaleH = elRect.height / sh;
        const scaleW = elRect.width / sw;
        this._context_scaleX = scaleW;
        this._context_scaleY = scaleH;

        this._context_scale = scaleH < scaleW ? scaleH : scaleW;
    }

    get shadowsize() {
        return this._shadowsize !== "undefined" ? this._shadowsize : 3;
    }
    set shadowsize(value) {
        this._shadowsize = value;
        this._drawShadow();
    }

    get shadowcolor() {
        return typeof this._shadowcolor !== "undefined"
            ? this._shadowcolor
            : "rgba(35, 39, 76, 0.5)";
    }
    set shadowcolor(v) {
        this._shadowcolor = v;
        this._drawShadow();
    }

    get isenabled() {
        return this._isenabled;
    }
    set isenabled(value) {
        this._isenabled = this._toBool(value);
        if (this._disabled)
            this._disabled.style.display = this._isenabled ? "none" : "block";
    }

    get boundsrestricted() {
        return this._boundsrestricted;
    }
    set boundsrestricted(value) {
        this._boundsrestricted = this._toBool(value);
        this._dnd.option.controlPosition = this._boundsrestricted;
    }

    get default() {
        return this._default;
    }
    set default(value) {
        this._default = value;

        if (value) {
            document.addEventListener("keypress", this.onDefault);
        } else {
            document.removeEventListener("keypress", this.onDefault);
        }
    }

    get onclose() {
        return this._onclose;
    }
    set onclose(v) {
        this._onclose = v;
    }

    get maxwidth() {
        return this._maxwidth;
    }
    set maxwidth(value) {
        this._maxwidth = value;
        this._popup.style.maxWidth = `${value}px`;
    }

    get wincategory() {
        return this._wincategory;
    }
    set wincategory(value) {
        this._wincategory = value;
    }

    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "afterswitch":
                const curWin = this.firstChild?.id
                if(!(curWin !== undefined && $pm.checkOpenWindowRights(curWin))){
                    this.close();
                }
                break;
        }
    }

    onDefault(e) {
        if (e.key === "Enter" && this._popup.classList.contains("active")) {
            e.preventDefault();
            this._default();
        }
    }

    _drawShadow() {
        if (!this._popup)
            return;
        if (this._shadowsize && this._shadowcolor) {
            this._popup.style.setProperty(
                "--popup-shadow",
                `${this._shadowsize}px ${this._shadowsize}px 10px ${this._shadowcolor}`
            );
        } else {
            this._popup.style.setProperty(
                "--popup-shadow",
                "0px 3px 10px rgba(35, 39, 76, 0.5)"
            );
        }
    }

    _onResize = () => {
        this._calcSize();
        this.positionWindowResize();
        this._calcScalePop()
    }

    disconnectedCallback() {
        window.removeEventListener("ms_message", this.afterSwitch);
        window.removeEventListener("resize", this._onResize)
        if (this._dnd) {
            delete this._dnd;
        }
        this._resizeEl.onmousedown = null;
        this._resizeEl.removeEventListener("touchstart", this._onNTouchStart);
        this._b_resizeEl.onmousedown = null;
        this._b_resizeEl.removeEventListener("touchstart", this._onBTouchStart);
        this._r_resizeEl.onmousedown = null;
        this._r_resizeEl.removeEventListener("touchstart", this._onRTouchStart);
        delete this._context;
        document.removeEventListener("keypress", this.onDefault);
        this._popup.removeEventListener('mousedown', this._startDrag.bind(this))
        super.disconnectedCallback();
    }

    connectedCallback() {
        this.positionPreloader(); // нужно для центрирования прелоадера
        window.addEventListener("resize", this._onResize)

        if (!this.titlefontcolor) {
            this._title.style.color = "white";
        }
    }

    positionWindow(dockstyle) {
        if (!this._context || this.firstPos) return;
        const scaleX = this.scaleXX || this.scale || 1;
        const scaleY = this.scaleYY || this.scale || 1;
        // Используем requestAnimationFrame, чтобы дождаться рендера
        requestAnimationFrame(() => {
            if (!this._popup) return;
            switch (this.opendialogpoint) {
                case 0: {
                    const target = this._context.currentTarget || this._context.target;
                    const el = this._context.detail?.el || target;
                    const rect = el.getBoundingClientRect();
                    const hostRect = this.getBoundingClientRect();
                    const x = (rect.right - hostRect.left) + (this.offsetx * this._context_scaleX);
                    const y = (rect.top   - hostRect.top)  + (this.offsety * this._context_scaleY);
                    this.setPositionEl(x, y, el, scaleX, scaleY);
                    break;
                }
                case 1: {
                    const { detail } = this._context;
                    const ev = detail && (detail.pageX !== undefined || detail.clientX !== undefined) ? detail : this._context;
                    const clientX = (ev.clientX !== undefined) ? ev.clientX : (ev.pageX - window.scrollX);
                    const clientY = (ev.clientY !== undefined) ? ev.clientY : (ev.pageY - window.scrollY);
                    const hostRect = this.getBoundingClientRect();
                    const x = (clientX - hostRect.left) + (this.offsetx * this._context_scaleX);
                    const y = (clientY - hostRect.top)  + (this.offsety * this._context_scaleY);

                    setTimeout(() => {
                        if (!this._popup) return;
                        this.pageX = this._popup.getBoundingClientRect().right - this._popup.clientWidth * scaleX;
                        this.pageY = this._popup.getBoundingClientRect().bottom - this._popup.clientHeight * scaleY;
                        this.initialPopupWidth = this._popup.clientWidth * scaleX;
                        this.initialPopupHeight = this._popup.clientHeight * scaleY;
                        const rect = this._popup.getBoundingClientRect();
                        this.lastPosition = {
                            x: rect.left / scaleX,
                            y: rect.top / scaleY
                        };
                    }, 0);
                    this.setPositionEl(x, y, null, scaleX, scaleY);
                    break;
                }

                case 2:
                    this.setPositionEl(this._offsetx * this._context_scaleX , this._offsety * this._context_scaleY, null , scaleX , scaleY);
                    break;
                case 3:
                    default: {
                        const { clientWidth, clientHeight } = document.documentElement;
                        const left = (clientWidth - this._popup.clientWidth * scaleX) / 2;
                        const top  = (clientHeight - this._popup.clientHeight * scaleY) / 2;
                        this.lastPosition = { x: left / scaleX, y: top / scaleY };
                        this._popup.style.transform = `translate(${left}px, ${top}px) scale(${scaleX}, ${scaleY})`;
                        this._popup.style.transformOrigin = "top left";
                        break;
                    }
            }
        });
    }

    positionPreloader() {
        const scaleX = this.scaleXX || this.scale || 1;
        const scaleY = this.scaleYY || this.scale || 1;
        const { clientWidth, clientHeight } = document.documentElement;
        const left = (clientWidth - this._popup.clientWidth * scaleX || 1) / 2;
        const top = Math.max(0, (clientHeight - this._popup.clientHeight * scaleY || 1) / 2);
        this._popup.style.transform = `translate(${left}px, ${top}px) scale(${scaleX}, ${scaleY})`;
        this._popup.style.transformOrigin = "top left";
    }

    positionWindowResize(dockstyle) {
        const template = $WinDefs.winDef[window.activeMonitorTemplateId];
        if(!template) return;
        const scaleX = this.scaleXX || this.scale || 1;
        const scaleY = this.scaleYY || this.scale || 1;
        let x = 0;
        let y = 0;
        requestAnimationFrame(() => {
            if (!this._popup) return;
            if (this._isPopupManualResizing) {
                const x = (this.lastPosition?.x ?? 0) * scaleX;
                const y = (this.lastPosition?.y ?? 0) * scaleY;

                this._popup.style.transform = `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY})`;
                this._popup.style.transformOrigin = "top left";
                return;
            }
            if (this.lastPosition && (this.positionManuallyChanged || this.opendialogpoint !== 3)) {
                x = this.lastPosition.x * scaleX;
                y = this.lastPosition.y * scaleY;
                const popupWidth = this._popup.clientWidth * scaleX;
                const popupHeight = this._popup.clientHeight * scaleY;
                const viewportWidth = document.documentElement.clientWidth;
                const viewportHeight = document.documentElement.clientHeight;
    
                if (this._boundsrestricted) {
                    if (x + popupWidth > viewportWidth) x = viewportWidth - popupWidth;
                    if (x < 0) x = 0;
                    if (y + popupHeight > viewportHeight) y = viewportHeight - popupHeight;
                    if (y < 0) y = 0;
                }
                this._popup.style.transform = `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY})`;
                this._popup.style.transformOrigin = "top left";
                return;
            }
    
            switch (this.opendialogpoint) {
                case 0: {
                    const target = this._context.currentTarget || this._context.target;
                    const el = this._context.detail?.el || target;
                    const rect = el.getBoundingClientRect();
                    const hostRect = this.getBoundingClientRect();
                    const x = (rect.right - hostRect.left) + (this.offsetx * this._context_scaleX);
                    const y = (rect.top - hostRect.top)  + (this.offsety * this._context_scaleY);
                    this.setPositionEl(x, y, el, scaleX, scaleY);
                    break;
                }
                case 1: {
                    const pageX = this.pageX * (this.scaleFactorWidth ?? 1);
                    const pageY = this.pageY * (this.scaleFactorHeight ?? 1);
                    setTimeout(() => {
                        if (!this._popup) return;
                        const newWidth = this._popup.clientWidth * scaleX;
                        const newHeight = this._popup.clientHeight * scaleY;
                        this.scaleFactorWidth = newWidth / this.initialPopupWidth;
                        this.scaleFactorHeight = newHeight / this.initialPopupHeight;
                    }, 0);
                    this.setPositionEl(pageX, pageY, null, scaleX, scaleY);
                    break;
                }
                case 2:
                    this.setPositionEl(this._offsetx * scaleX * this._context_scaleX, this._offsety * scaleY * this._context_scaleY, null, scaleX, scaleY);
                    break;
                case 3:
                default: {
                    const { clientWidth, clientHeight } = document.documentElement;
                    let left;
                    let top;
                    if (this._boundsrestricted) {
                        top = Math.max(0, (clientHeight - this._popup.clientHeight * scaleY || 1) / 2);
                        left = Math.max(0, (clientWidth - this._popup.clientWidth * scaleX || 1) / 2);
                    } else {
                        top = (clientHeight - this._popup.clientHeight * scaleY || 1) / 2;
                        left = (clientWidth - this._popup.clientWidth * scaleX || 1) / 2;
                    }
                    this._popup.style.transform = `translate(${left}px, ${top}px) scale(${scaleX}, ${scaleY})`;
                    this._popup.style.transformOrigin = "top left";
                    break;
                }
            }
        });
    }

    getPopupPos(dockstyle, { left, top, width, height }) {
        switch (dockstyle) {
            // Выравнивание относительно контекста
            case 0: {
                // верх
                return {
                    x: left + this.offsetx * this._context_scale,
                    y:
                        top -
                        this._popup.offsetHeight +
                        this.offsety * this._context_scale,
                };
            }
            case 1: {
                // Низ
                return {
                    x: left + this.offsetx * this._context_scale,
                    y: top + height + this.offsety * this._context_scale,
                };
            }
            case 2: {
                // Право
                return {
                    x: left + width + this.offsetx * this._context_scale,
                    y: top + this.offsety * this._context_scale,
                };
            }
            case 3: {
                // Лево
                return {
                    x:
                        left -
                        this._popup.offsetWidth +
                        this.offsetx * this._context_scale,
                    y: top + this.offsety * this._context_scale,
                };
            }
            default: {
                throw new Error(`Incorrect dockstyle value: ${dockstyle}`);
            }
        }
    }

    setPositionEl(x, y, el, scaleX = 1, scaleY = 1) {
        const template = $WinDefs.winDef[window.activeMonitorTemplateId];
        if(!template) return;
        const popupWidth = this._popup.clientWidth * scaleX;
        const popupHeight = this._popup.clientHeight * scaleY;
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
    
        let maxX = viewportWidth - popupWidth;
        let maxY = viewportHeight - popupHeight;
    
        if (this._boundsrestricted) {
            if (x + popupWidth > viewportWidth) {
                x = maxX;
            }
            if (x < 0) x = 0;
            if (y + popupHeight > viewportHeight) {
                y = maxY;
            }
            if (y < 0) {
                y = Math.max(0, y);
            }
        }
        if ((template.widthtype === "0" && template.heighttype === undefined && this.opendialogpoint === 0) || (template.widthtype === undefined && template.heighttype === "0" && this.opendialogpoint === 0)) {
            this._popup.style.transform = `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY})`;
            this._popup.style.transformOrigin = "top left";
        } else if ((template.widthtype === "0" && template.heighttype === undefined && this.opendialogpoint === 2) || (template.widthtype === undefined && template.heighttype === "0" && this.opendialogpoint === 2)) {
            if(this._offsetx * scaleX + popupWidth > viewportWidth || this._offsety * scaleY + popupHeight > viewportHeight) {
                this._popup.style.transform = `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY})`;
                this._popup.style.transformOrigin = "top left";
            } else {
                this._popup.style.transform = `translate(${this._offsetx * scaleX * this._context_scaleX}px, ${this._offsety * scaleY * this._context_scaleY}px) scale(${scaleX}, ${scaleY})`;
                this._popup.style.transformOrigin = "top left";
            }
        } else {
            this._popup.style.transform = `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY})`;
            this._popup.style.transformOrigin = "top left";
        }
    }

    openWindow(obj) {
        this._clearWin();
        let param = "";
        const keys = Object.keys(obj);
        keys.forEach(key => {
            if (key !== "windowTriggers" && key !== "dockstyle" && key !== "actionlist") {
                param += ` ${key}="${obj[key]}"`;
            }
        });
        this.closeWin = this.close.bind(this);
        const win = `<ms-window${param} position='absolute'></ms-window>`;

        let openingWindows = null;
        if ($sw.OpeningWindows == null) {
            openingWindows = [];
            $sw.OpeningWindows = openingWindows;
        }
        try
        {
            this.innerHTML = win;
        }
        catch (err) 
        {
           $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t('open_win_error') + obj.id,
                    text: err
                });
        }
        if (openingWindows != null) {
            $sw.OpeningWindows = null;
            if (openingWindows)
                $sw.ItemSubscription.AddWindows(openingWindows);
        }

        this._msWin = this.querySelector("ms-window");
        const isFrame = this._msWin.firstChild?.tagName === "MS-FRAME";
        const iframeUrl = obj.popupUrl
            || (this._msWin.children.length === 1 && isFrame && isValidUrl(this._msWin.firstChild.datasource));
        if (iframeUrl) {
            this.popupUrl = iframeUrl;
            this._msWin.style.width = "100%";
            this._msWin.style.height = "100%";
            if (!isFrame) {
                this._msWin.insertTemplateHTML(`<ms-frame x="0" y="0" z="1" tabindex="1" datasource="${iframeUrl}" proportiontype="0"></ms-frame>`);
                this._msWin.firstChild.isPopupIframe = true;
                this._msWin.firstChild.width = "100%";
                this._msWin.firstChild.height = "100%";
            } else {
                // Это обновление размеров нужно, чтобы при изменении размеров окна iframe применял максимальные доступные ему размеры и при этом не скалировался.
                this._msWin.firstChild.isPopupIframe = true;
                this._msWin.firstChild.width = this._msWin.firstChild.width;
                this._msWin.firstChild.height = this._msWin.firstChild.height;
            }
        }

        this._msWin.closeWin = this.close.bind(this);
        if (obj["windowTriggers"] && !this._msWin.windowTriggers) {
            //TODO
            this._msWin.windowTriggers = JSON.parse(
                JSON.stringify(obj.windowTriggers)
            );
        }
        this._upWindow();
        this._msWin.afterInitialize();
        this._calcSize();
        this._calcScale();
        this.positionManuallyChanged = false;
        this.lastPosition = null;
        this.positionWindow(obj.dockstyle);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (!this._popup) return;
                this._calcScalePop();
                this.forceResizeTrigger();
            });
        });
        
        return this._msWin;
    }

    forceResizeTrigger() {
        const event = {
            pageX: this._popup.getBoundingClientRect().right + 10,
            pageY: this._popup.getBoundingClientRect().bottom + 10,
            targetTouches: null
        };
        this._reSizeWindow("n", event , true);
        document.dispatchEvent(new Event("mouseup"))
    }

    onResizeContent() {
        if (this.sizetocontent === 0) {
            //real size
            this._calcSize();
            this.positionWindowResize(this.dockstyle ?? 3);
        }
    }

    

    _reSizeWindow(type, e , force = false) {
        if (e.targetTouches) e = e.targetTouches[0];
        if (!force && this.sizetocontent === 0) {
            this.sizetocontent = window._enums.SizeToContentType.SetSize;
        }
        if (!force) {
            this._isPopupManualResizing = true;

            const scaleX = this.scaleXX || this.scale || 1;
            const scaleY = this.scaleYY || this.scale || 1;
            const tr = getComputedStyle(this._popup).transform;
            let tx = 0, ty = 0;
            if (tr && tr !== "none") {
                const m = new DOMMatrixReadOnly(tr);
                tx = m.m41;
                ty = m.m42;
            }
            this.lastPosition = { x: tx / scaleX, y: ty / scaleY };
            this.positionManuallyChanged = true;
        }

        const template = $WinDefs.winDef[window.activeMonitorTemplateId];
        if(!template) return;
        const mainCoords = this.getCoords(this._resizeEl);
        const shiftX = mainCoords.left + (e.pageX - mainCoords.left);
        const shiftY = mainCoords.top + (e.pageY - mainCoords.top);
        const scaleW = mainCoords.width / this._resizeEl.clientWidth;
        const scaleH = mainCoords.height / this._resizeEl.clientHeight;

        const popup_width = (this._width = this._popup.clientWidth);
        const popup_height = (this._height = this._popup.clientHeight);

        this._work.style.height = `100%`;
        this._work.style.width = `100%`;
        const mouseMove = e => {
            if (this.popupUrl) {
                this._msWin.querySelector("iframe").style.pointerEvents = 'none';
            }

            if (e.targetTouches) e = e.targetTouches[0];
            let newLeft = (e.pageX - shiftX) / scaleW;
            let newTop = (e.pageY - shiftY) / scaleH;
        
            if (newLeft + popup_width < this._popup.clientLeft + 80) {
                newLeft = 80 - popup_width;
            }
            if (newTop + popup_height < this._popup.clientTop + 40) {
                newTop = 40 - popup_height;
            }
        
            if (type !== "r") {
                this._height = popup_height + newTop;
            }
            if (type !== "b") {
                this._width = popup_width + newLeft;
            }
        
            this._popup.style.width = `${this._width}px`;
            this._popup.style.height = `${this._height}px`;
            if (this.popupUrl) { // Если popup содержит iframe с отображением стороннего сайта, тогда не нужно скалировать window, сайт должен самостоятельно подстраиваться под размеры iframe
                return;
            }
            this._calcSize();
            this._calcScalePop();
            this.positionWindowResize();
        };

        const mouseUp = () => {
            if (this.popupUrl) {
                this._msWin.querySelector("iframe").style.pointerEvents = 'auto';
            }
            document.removeEventListener("mousemove", mouseMove);
            document.removeEventListener("mouseup", mouseUp);
            document.removeEventListener("touchmove", mouseMove);
            document.removeEventListener("touchend", mouseUp);
            this._isPopupManualResizing = false;

        };

        document.addEventListener("touchmove", mouseMove);
        document.addEventListener("touchend", mouseUp);

        document.addEventListener("mousemove", mouseMove);
        document.addEventListener("mouseup", mouseUp);
        

        return false;
    }

    getCoords(elem) {
        var box = elem.getBoundingClientRect();
        return {
            top: box.top + pageYOffset,
            left: box.left + pageXOffset,
            width: box.width,
            height: box.height,
        };
    }

    _calcSize() {
        if (!this._msWin) {
            this._work.style.height = this._setValueUnit(this.height);
            this._work.style.width = this._setValueUnit(this.width);
            return;
        }
  
        this._msWin.style.position = "relative";
        this._msWin.style.transform = "";
        this._msWin.style.transformOrigin = "";
        const headerSize = this.screenOptions?.DialogHeaderSize || 0;
        if (!this._isPopupManualResizing) {
            this._calcScale();
        }
    
        switch (this._sizetocontent) {
            case window._enums.SizeToContentType.RealSize: {
                this._work.style.overflow = "";
                this._work.style.height = this._setValueUnit(this._msWin.offsetHeight);
                this._work.style.width = this._setValueUnit(this._msWin.offsetWidth);
                this._popup.style.height = this._setValueUnit(this._msWin.offsetHeight + headerSize);
                this._popup.style.width = this._setValueUnit(this._msWin.offsetWidth);
                break;
            }
            case window._enums.SizeToContentType.SetSize: {
                this._msWin.style.overflow = "";
                this._work.style.overflow = ""
                break;
            }
            case window._enums.SizeToContentType.Crop: {
                this._work.style.overflow = "hidden";
                this._work.style.width = this._setValueUnit(this._width);
                this._work.style.height = this._setValueUnit(this._height);
                break;
            }
            case window._enums.SizeToContentType.Scroll: {
                this._work.style.overflow = "auto";
                break;
            }
            default: {
                this._work.style.overflow = "";
                this._work.style.height = this._setValueUnit(this._msWin.offsetHeight);
                this._work.style.width = this._setValueUnit(this._msWin.offsetWidth);
                this._popup.style.height = this._setValueUnit(this._msWin.offsetHeight + headerSize);
                this._popup.style.width = this._setValueUnit(this._msWin.offsetWidth);
                break;
            }
        }
        if (!this._isPopupManualResizing) {
            this._calcScale();
        }
    }

    _calcScale() {
        if (!this._msWin && this._scale) return;
        const template = $WinDefs.winDef[window.activeMonitorTemplateId];
        if (!template) return;
        const templateWidth = template.width;
        const templateHeight = template.height;
        const scaleX = document.documentElement.clientWidth / templateWidth;
        const scaleY = document.documentElement.clientHeight / templateHeight;
        const widthType = template.widthtype;
        const heightType = template.heighttype;
        const proportionType = template.proportiontype;

        let scale = 1;
        
        if (widthType === "0" && heightType === "0") {
            this._popup.style.transform = `scale(${scale})`;
            return;
        }
        
        if (widthType === "0" && heightType === undefined) {
            this.scaleYY = scaleY;
            this._popup.style.transform = `scale(${scale}, ${this.scaleYY})`;
            return;
        }
        
        if (heightType === "0" && widthType === undefined) {
            this.scaleXX = scaleX;
            this._popup.style.transform = `scale(${this.scaleXX}, ${scale})`;
            return;
        }
        
        if (proportionType === "0") {
            this.scaleXX = scaleX;
            this.scaleYY = scaleY;
            this._popup.style.transform = `scale(${this.scaleXX}, ${this.scaleYY})`;
        } else {
            if (proportionType === "1") {
                scale = scaleX;
            } else if (proportionType === "2") {
                scale = scaleY;
            } else if (proportionType === "3" || proportionType === "4") {
                scale = Math.max(scaleX, scaleY);
            } else {
                scale = Math.min(scaleX, scaleY);
            }
            this._scale = scale;
            this._popup.style.transform = `scale(${scale})`;
        }
        this._popup.style.transformOrigin = "0 0";
    }

    _minimize() {
        this._work.style.display = this._mini ? "none" : "block";
    }

    close() {
        if (this._onclose) this._onclose();
        this.onmousedown = null;
        if (this._msWin) this._msWin.remove();
        delete this._msWin;
        $WinService.removeWindow(this);
    }

    /**
     * Очистка окна
     *
     * @memberof MSPopUpWindow
     */
    _clearWin() {
        while (this.firstChild) {
            this.removeChild(this.firstChild);
        }
    }

    /**
     * Установка приоритета окна на самый верх
     *
     * @memberof MSPopUpWindow
     */
    _upWindow(maxZIndex) {
        if (!this.parentNode) return;
        this.parentNode.childNodes.forEach(element => {
            if (element.nodeName == "MS-POPUP") {
                if (element !== this) {
                    element.style.zIndex = this._toBool(element.modal)
                        ? (maxZIndex ? maxZIndex-1 : "10002000")
                        : "10000000";
                    if (!this._toBool(element.modal))
                        element._popup.classList.remove("active");
                } else {
                    element.style.zIndex = this._toBool(element.modal)
                        ? (maxZIndex ? maxZIndex-1 : "10003000")
                        : "10001000";
                    element._popup.classList.add("active");
                }
            }
        });
    }

    colorValues(color) {
        if (!color) return;
        if (color.toLowerCase() === "transparent") return [0, 0, 0, 0];
        if (color[0] === "#") {
            if (color.length < 7) {
                color =
                    "#" +
                    color[1] +
                    color[1] +
                    color[2] +
                    color[2] +
                    color[3] +
                    color[3] +
                    (color.length > 4 ? color[4] + color[4] : "");
            }
            return [
                parseInt(color.substr(1, 2), 16),
                parseInt(color.substr(3, 2), 16),
                parseInt(color.substr(5, 2), 16),
                color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1,
            ];
        }
        if (color.indexOf("rgb") === -1) {
            var temp_elem = document.body.appendChild(
                document.createElement("fictum")
            );
            var flag = "rgb(1, 2, 3)";
            temp_elem.style.color = flag;
            if (temp_elem.style.color !== flag) {
                document.body.removeChild(temp_elem);
                return;
            }
            temp_elem.style.color = color;
            if (
                temp_elem.style.color === flag ||
                temp_elem.style.color === ""
            ) {
                document.body.removeChild(temp_elem);
                return;
            }
            color = getComputedStyle(temp_elem).color;
            document.body.removeChild(temp_elem);
        }
        if (color.indexOf("rgb") === 0) {
            if (color.indexOf("rgba") === -1) color += ",1";
            return color.match(/[\.\d]+/g).map(a => {
                return +a;
            });
        }
    }

    _calcScalePop() {
        // Если popup содержит iframe с отображением стороннего сайта, тогда не нужно скалировать window, сайт должен самостоятельно подстраиваться под размеры iframe
        if (!this._msWin || this.popupUrl) return;
        if (this._sizetocontent !== window._enums.SizeToContentType.SetSize) {
            this._msWin.style.transform = "";
            this._msWin.style.transformOrigin = "";
            return;
        }
        const scY = this._msWin.offsetHeight || 1;
        const scX = this._msWin.offsetWidth || 1;
        const headerSize = this.screenOptions?.DialogHeaderSize || 0;
        const scaleY = (this._popup.clientHeight - headerSize) / scY;
        const scaleX = this._popup.clientWidth / scX;
        
        const template = $WinDefs.winDef[window.activeMonitorTemplateId];
        if(!template) return;
        const tplProp = template.proportiontype;
        // важно: '0' должно сохраниться, поэтому НЕ через ||
        const proportion = (tplProp !== undefined && tplProp !== null)
            ? Number(tplProp)
            : this._msWin.proportiontype;
        const widthType = template?.widthtype;
        const heightType = template?.heighttype;
        let transform = "";
        if (widthType === undefined && heightType === undefined) {
            if (proportion === 1) {
                transform = `scale(${scaleX}, ${scaleX})`;
            } else if (proportion === 2) {
                transform = `scale(${scaleY}, ${scaleY})`;
            } else if (proportion === 0) {
                transform = `scale(${scaleX}, ${scaleY})`;
            } else if (proportion === 3) {
                const scale = Math.max(scaleX, scaleY);
                transform = `scale(${scale}, ${scale})`;
            } else {
                const scale = Math.min(scaleX, scaleY);
                transform = `scale(${scale})`;
            }
        } else if (widthType === undefined && heightType === "0") {
            transform = `scale(${scaleX}, 1)`;
        } else if (heightType === undefined && widthType === "0") {
            transform = `scale(1, ${scaleY})`;
        } else {
           transform = (proportion === 0) ? `scale(${scaleX}, ${scaleY})` : ``;
        }
    
        this._msWin.style.transform = transform;
        this._msWin.style.transformOrigin = transform ? "0 0" : "";
    }

    colourIsLight(r, g, b) {
        var a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return a < 0.5;
    }
}
